import { render, staticRenderFns } from "./ChangeManagerDialog.vue?vue&type=template&id=0cff4cfd&scoped=true"
import script from "./ChangeManagerDialog.vue?vue&type=script&lang=js"
export * from "./ChangeManagerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cff4cfd",
  null
  
)

export default component.exports